import React from "react";

import useChargingSessionAdmin from "../../../../hooks/useChargingSession";
import  ChargingSessionListView from "../ChargingSessionListView/ChargingSessionListView";
import Pagination from "../../../../../../common/components/organisme/Pagination/Pagination";
import { LoaderSreen } from "../../../../../../common/components/molecule/Loader/Loader";
import ErrorScreenApp from "../../../../../errorHandler/components/ErrorScreenApp/ErrorScreenApp";
import { dateConverter } from "../../../../../../common/utils/dateConverter";
import useNavigationApp from "../../../../../../navigation/useNavigationApp";
import ButtonSmallIcon from "../../../../../../common/components/atom/ButtonSmallIcon/ButtonSmallIcon";
import { SingleStation } from "../../../../../stations/components/SingleStation";
import SingleOrganization from "../../../../../organization/components/SingleOrganization";
import SingleClient from "../../../../../clients/components/SingleClient";
import { numberFormaterString } from "../../../../../../utils/numberFormater";
import { Filter, OrderByType } from "../../../../../../utils/genericAPI/useGenericAPI";
import { ChargingSession, ChargingSessionPatch } from "../../../../types/chargingSession.types";


export default function ChargingSessionListPresenter({sizePage, preFilter, orberBy}:{sizePage?: number, orberBy?: OrderByType<ChargingSession>, preFilter?:  Filter<ChargingSessionPatch>}) {
  const {
    getAllChargingSession: { data, isError, isLoading, setPage, error },
  } = useChargingSessionAdmin({
    pageSize: sizePage || 10,
    orderBy: orberBy,
    filter: preFilter as Filter<ChargingSessionPatch>,
  });

  const navigation = useNavigationApp()

  return (
    <>
      {isLoading && <LoaderSreen heigth={"200px"} />}
      {isError && <ErrorScreenApp axiosError={error} />}
      {!isLoading && !isError && < ChargingSessionListView content = {
        data?.data?.map(item => ({
            id: item.cs_id,
            createAt: dateConverter(item.cs_create_at),
            kWhAmount: item.cs_nb_kwh.toFixed(2),
            price: numberFormaterString(item.cs_price),
            currency: item.cs_currency,
            onClick: () =>{ navigation.goToSingleChargingSession(item.cs_id, true)},
            clientRender: () => {
              if (!item.cs_client || item.cs_client === "") {
                return <>{item.cs_client_number_phone}</>;
              }
              return  <> <SingleClient.Info info="client_firstname" id={item.cs_client} emptyText="Aucun" />{" "} <SingleClient.Info info="client_lastname" id={item.cs_client} emptyText="Aucun" /></>
            },
            stationRender: () =>(
                      <ButtonSmallIcon
                        width={"80px"}
                        iconType={"electricStation"}
                        valueRender={() => <SingleStation.Name idStation={item.cs_station} limit={7} />}
                        onClick={(e) => {  e.stopPropagation(); navigation.goToSingleStation(item.cs_station)}}
                      />
            )
               ,
            organisationRender: () => <SingleOrganization.Info info="organization_name" id={item.cs_organization} emptyText="Aucune"/>,
        }))
      }
      nbFound={data?.pagination?.total_count}

      />}
      <Pagination
        centered
        setCurrentPage={setPage}
        currentPage={data?.pagination?.current_page}
        lastPage={data?.pagination.total_pages}
        nbBtnToDisplay={5}
      />
    </>
  );
}
